import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { WizardOption } from 'src/app/models/wizard/wizard-option';
import { WizardStep } from 'src/app/models/wizard/wizard-step';
import { ConfigService } from 'src/app/services/config/config.service';
import { WizardService } from 'src/app/services/wizard/wizard.service';
import { AnalyticsService, AnalyticsUtility } from 'src/app/services/analytics/analytics.service';
import { WizardStepName } from 'src/app/services/wizard/wizard-step-name.enum';
import { UtilityService } from 'src/app/services/utility.service';

@Component({
  selector: 'app-brands-step',
  templateUrl: './brands-step.component.html',
  styleUrls: ['./brands-step.component.scss']
})
export class BrandsStepComponent implements OnInit {
  title: string = "";
  subtitleBeginning: string = "";
  subtitleMiddle: string = "";
  subtitleEnd: string = "";
  i18nSubtitle: string = "";
  isEnglish: boolean = true;
  currentStep: WizardStep = new WizardStep();
  stepNumber: number = 0;
  brandOptions: WizardOption[] = [];
  selectedOptions: WizardOption[] = [];
  isContinueBtnDisabled: boolean = true;
  imageBasePath: string = "./../../../assets/images/";
  brandFileType: string = ".svg";
  analyticsStepName: string = AnalyticsUtility.wizardStepName.brand;

  constructor(
    private analyticsService: AnalyticsService,
    public wizardService: WizardService,
    private route: ActivatedRoute,
    private confSvc: ConfigService,
    private utilityService: UtilityService) { }

  async ngOnInit(): Promise<void> {
    await this.confSvc.setup();

    this.currentStep = this.wizardService.getStep(WizardStepName.Brands);
    this.stepNumber = this.wizardService.getStepNumber(this.currentStep.name);

    this.title = this.confSvc.getString("brandsTitle");
    this.subtitleBeginning = this.confSvc.getString("wizardStepSubtitleBeginning");
    this.subtitleMiddle = this.confSvc.getString("multipleSelectionWizardStepSubtitleMiddle");
    this.subtitleEnd = this.confSvc.getString("multipleSelectionWizardStepSubtitleEnd");
    this.i18nSubtitle = this.confSvc.getString("i18nMultipleSelectionWizardStepSubtitle");

    this.isEnglish = this.utilityService.getLocaleInfo().isEnglish;

    this.route.queryParams.subscribe(params => {
      this.wizardService.setSelectedOptionsFromUrlIfPresent(params);

      this.setBrandOptions();
    });
    this.analyticsService.logCurrentPage(this.analyticsStepName);
  }

  setBrandOptions(): void {
    this.wizardService.getSelectedWizardOptionsForStep(this.currentStep.name)
      .subscribe(selectedOptions => {
        this.selectedOptions = selectedOptions;

        this.isContinueBtnDisabled = this.selectedOptions.length === 0;

        const brands = this.confSvc.getStringArray("brandsOptionsToDisplay")
                                      .sort((a, b) => a.localeCompare(b, undefined, {sensitivity: 'base'}));
        brands.forEach(brand => {
          this.addBrandOption(brand);
        });
        this.addNoPreferenceOption();
      });
  }

  addBrandOption(brandName: string): void {
    const imagePath = `${this.imageBasePath}${brandName}${this.brandFileType}`;

    this.brandOptions.push(Object.assign(new WizardOption(), {
      step: this.currentStep,
      title: brandName,
      imgSrc: imagePath,
      isSelected: this.selectedOptions.some(option => option.title === brandName)
    }));
  }

  addNoPreferenceOption(): void {
    this.brandOptions.push(Object.assign(new WizardOption(), {
      step: this.currentStep,
      title: this.confSvc.getString("brandNoPreferenceOptionTitle"),
      iconFontSet: 'fas',
      iconName: 'fa-question-circle',
      isSelected: this.selectedOptions.some(option => option.title === this.confSvc.getString("brandNoPreferenceOptionTitle"))
    }))
  }

  updateWizardSelection(option: WizardOption): void {
    if(option.isSelected) {
      this.wizardService.addSelectedWizardOption(option);
    } else {
      this.wizardService.removeSelectedWizardOption(option.title);
    }
  }

  onSelect(event: WizardOption): void {
    // when no preference is selected - updating all other options that have been selected to false
    if (event.title === this.confSvc.getString("brandNoPreferenceOptionTitle") && event.isSelected) {
      this.brandOptions.map(item => {
        if(item.title !== this.confSvc.getString("brandNoPreferenceOptionTitle") && item.isSelected) {
          item.isSelected = false;
          this.updateWizardSelection(item);
        } else {
          this.updateWizardSelection(item);
        }
      });
    } else {
      this.brandOptions.map(item => {
        if (item.title === event.title) {
          item.isSelected = event.isSelected;
          this.updateWizardSelection(item);
        }
        // When an item is selected, but no preference was previously selected - setting no pref to false
        if (item.title === this.confSvc.getString("brandNoPreferenceOptionTitle") && item.isSelected) {
            item.isSelected = false;
            this.updateWizardSelection(item);
        }
      })
    }

    this.isContinueBtnDisabled = !this.brandOptions.some(item => {
      return item.isSelected === true;
    });
  }
}
